<script lang="ts" setup></script>

<template>
  <section class="section4">
    <figure class="section4__img zonezoneBox5__slide__img1">
      <Nimg src="./images/career/carousel1.jpg" alt="人才發展輪播圖1" />
    </figure>
    <figure class="section4__img zonezoneBox5__slide__img2">
      <Nimg src="./images/career/carousel2.jpg" alt="人才發展輪播圖2" />
    </figure>
    <figure class="section4__img zonezoneBox5__slide__img3">
      <Nimg src="./images/career/carousel3.jpg" alt="人才發展輪播圖3" />
    </figure>
    <figure class="section4__img zonezoneBox5__slide__img4">
      <Nimg src="./images/career/carousel1.jpg" alt="人才發展輪播圖1" />
    </figure>
    <figure class="section4__img zonezoneBox5__slide__img5">
      <Nimg src="./images/career/carousel2.jpg" alt="人才發展輪播圖2" />
    </figure>
    <figure class="section4__img zonezoneBox5__slide__img6">
      <Nimg src="./images/career/carousel3.jpg" alt="人才發展輪播圖3" />
    </figure>
  </section>
</template>

<style lang="scss" scoped>
@keyframes infiniteSlide {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

.section4 {
  display: flex;
  width: max-content;
  margin-bottom: toRem(300);
  animation: infiniteSlide 50s linear infinite;

  @include max-media(640) {
    margin-bottom: toRem(160);
  }

  &__img {
    display: flex;
    align-items: flex-start;
    width: 20%;
    padding-right: toRem(24);
    flex-shrink: 0;

    @include max-media(640) {
      width: 40%;
    }

    @include max-media(480) {
      width: 32%;
    }

    img {
      display: block;
      width: 100%;
    }
  }
}
</style>
